export const Menu = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 10H28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M4 16H28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M4 22H28" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
